(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // JavaScript code
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    const homepageHeaderWithoutCookie = document.getElementById('homepage-header-without-cookie');
    const homepageHeaderWithCookie = document.getElementById('homepage-header-with-cookie');
    if (!homepageHeaderWithCookie || !homepageHeaderWithoutCookie) return;
    if (getCookie('pinter_fp_hp') === 'false') {
      homepageHeaderWithCookie.style.display = 'block';
      homepageHeaderWithoutCookie.style.display = 'none';
    } else {
      homepageHeaderWithoutCookie.style.display = 'block';
      homepageHeaderWithCookie.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
